import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTriangleExclamation,
  faTrash,
  faCheck,
  faCircleInfo,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/shared/Modal.css';

const TONE_STYLES = {
  default: {
    icon: faCircleInfo,
    headerColor: '#2563eb',
    background: '#eff6ff',
    border: '#bfdbfe',
    text: '#1d4ed8',
    confirmClass: 'modal-save-btn',
    confirmStyle: {},
  },
  warning: {
    icon: faTriangleExclamation,
    headerColor: '#ea580c',
    background: '#fff7ed',
    border: '#fed7aa',
    text: '#9a3412',
    confirmClass: 'modal-save-btn modal-save-btn-warning',
    confirmStyle: {},
  },
  danger: {
    icon: faTrash,
    headerColor: '#dc2626',
    background: '#fef2f2',
    border: '#fecaca',
    text: '#991b1b',
    confirmClass: 'modal-save-btn modal-save-btn-danger',
    confirmStyle: {},
  },
};

const ActionConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  title = 'Onay Gerekli',
  message,
  details,
  consequences = [],
  confirmLabel = 'Onayla',
  cancelLabel = 'İptal',
  tone = 'warning',
  loading = false,
  icon,
}) => {
  const styles = TONE_STYLES[tone] || TONE_STYLES.warning;
  const resolvedIcon = icon || styles.icon;

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="admin-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon={resolvedIcon} className="me-2" style={{ color: styles.headerColor }} />
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          className="special-section"
          style={{
            background: styles.background,
            borderBottom: `1px solid ${styles.border}`,
          }}
        >
          <div className="special-section-header" style={{ color: styles.text }}>
            <FontAwesomeIcon icon={resolvedIcon} />
            <span>{tone === 'danger' ? 'Dikkat' : 'Bilgilendirme'}</span>
          </div>
          <div className="special-section-content action-confirmation-content">
            <div className="action-confirmation-message" style={{ color: styles.text }}>
              {message}
            </div>

            {details ? <div className="action-confirmation-details">{details}</div> : null}

            {consequences.length > 0 ? (
              <div className="action-confirmation-consequences">
                <div className="action-confirmation-consequences-title">Bu işlem sonucunda:</div>
                <ul>
                  {consequences.map((consequence) => (
                    <li key={consequence}>{consequence}</li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>

        <div className="modal-button-group">
          <Button variant="secondary" onClick={onClose} disabled={loading} className="modal-cancel-btn">
            <FontAwesomeIcon icon={faXmark} className="me-2" />
            {cancelLabel}
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={loading}
            className={styles.confirmClass}
            style={styles.confirmStyle}
          >
            <FontAwesomeIcon icon={resolvedIcon === faTrash ? faTrash : faCheck} className="me-2" />
            {loading ? 'İşleniyor...' : confirmLabel}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActionConfirmationModal;
